export default "__VITE_ASSET__CClesXQN__"